import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import './index.scss';

const TermsOfService = () => {
    return (
        <div className={'content'}>
            <div>
                <p>Our <b> privacy policy </b> explains how we collect and use your information while our<b> rules </b> 
                    outline your responsibilities when using our services. By using our services,
                    you are agreeing to be bound by these terms and our rules. Please see our
                    privacy policy for information about how we collect, use, share and otherwise
                    process information about you.
                </p>
            <br/>
            </div>
            <div>
                <b>CONTENT</b>
                <br/>
                <ul>
                    <li><Link className={'link'} to='/legal/terms-of-service#api-terms'>1. API Terms</Link></li>
                    <li><Link className={'link'} to='/legal/terms-of-service#service-pricing'>2. Service Pricing</Link></li>
                    <li><Link className={'link'} to='/legal/terms-of-service#service-payment'>3. Service Payment</Link></li>
                    <li><Link className={'link'} to='/legal/terms-of-service#cancel'>4. Cancellations and Refunds</Link></li>
                    <li><Link className={'link'} to='/legal/terms-of-service#service-termination'>5. Service termination</Link></li>
                </ul> 
                <br/>
            </div>
            <div>
                <div id={'api-terms'}>
                    <p>
                        <b>API Terms</b>
                    </p>
                    <br/>
                    <p>Users may access the API data through our order management system. All APIs
                        provided and available to users are the Provider's sole discretion.
                    </p>
                </div>
                <br/>
                <p id={'service-pricing'}>
                    <b>Service Pricing</b>
                </p>
                <br/>
                <p>
                    We offer multiple types of service plans - including, without limitation,
                    monthly service plans. You are responsible for all transactional costs of using
                    the service, not limited to postage, fees for private carriers, package
                    insurance, itbs purchased in the online store.
                </p>
                <br/>
                <p id={'service-payment'}>
                    <b>Service Payment</b>
                </p>
                <br/>
                <p>Shipsland accepts payment via the current payment method indicated at time of
                    purchase, which may include credit card and any other form of payment that we
                    make available to you from time to time.
                </p>
                <br/>
                <p id={'cancel'}>
                    <b>Cancellations and Refunds</b>
                </p>
                <br/>
                <p>You can cancel your subscriptions at any time. If you purchase a subscription
                    that automatically renews, you may cancel the subscription any time before the
                    end of the current billing period and the cancellation will take effect on the
                    next billing period, and will not receive a refund or credit for any rbaining
                    days in your current billing period.</p>
                <br/>
                <div id={'service-termination'}> 
                    <p>
                        <b>Service Terminations</b>
                    </p>
                    <br/>
                    <p>
                        Shipsland reserves the right to terminate  the service with notifications emails, if there is some indication of lack of payment and illegal purpose like copy, sell, rent or sublicense the member services to any third party, access the member service other than by means authorized by Shipsland.
                    </p>
                </div>
            </div>
        </div>
    );
}
export default TermsOfService;